var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"md":"6"}},[_c('span',[_vm._v(_vm._s(_vm.totalTime))])]),_c('v-col',{attrs:{"md":"6"}},[_c('AnnotationTimeLogs',{attrs:{"timeLogs":_vm.timeLogs}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }